module.exports = __webpack_public_path__ + "static/media/image10.d7ea0497.jpg";